App.namespace.wrap('es6.views.login.apple', function (options = {}) {
  const AppleLoginManager = App.es6.shared.apple_login_manager

  const {
    buttonId,
    appleUrl,
    appleClientId,
    appleRedirectUri,
    csrfToken,
    redirectUrl,
    defaultRedirectUrl = '/account/enquiries/current',
    trackingParams = {}
  } = options

  const callback = options.callback ?? (() => {
    if (redirectUrl && redirectUrl.indexOf(location.origin) === 0) {
      window.location = redirectUrl;
      return;
    }

    window.location = defaultRedirectUrl
  });

  const init = () => {
    const appleLoginOptions = {
      buttonId,
      appleUrl,
      appleClientId,
      appleRedirectUri,
      csrfToken,
      callback,
      autoLoginOnClick: true,
      trackingParams,
    }
    return AppleLoginManager(appleLoginOptions).init();
  }

  return {
    init
  }
});
